const keyboardDatePickerModalFilterExpiredServices = {
  from: 'De',
  to: 'Até'
};

export default keyboardDatePickerModalFilterExpiredServices;
